import axiosPrivate from "./axiosPrivate";

const guardarExpedientillo = (propuesta_solicitud_id, usuario_id, archivo_expedientillo) => {
  const formData = new FormData();
  formData.append("propuesta_solicitud_id", propuesta_solicitud_id);
  formData.append("usuario_id", usuario_id);
  formData.append("archivo_expedientillo", archivo_expedientillo);

  return axiosPrivate.post("guardarExpedientillo", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getExpedientillo = (propuesta_solicitud_id) => {
  return axiosPrivate.post("getExpedientillo", { propuesta_solicitud_id })
    .then(res => res.data.data);
};

const guardarAudio = (prospecto_id, usuario_id, archivo_audio) => {
  const formData = new FormData();
  formData.append("prospecto_id", prospecto_id);
  formData.append("usuario_id", usuario_id);
  formData.append("archivo_audio", archivo_audio);

  return axiosPrivate.post("guardarAudio", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getAudio = (prospecto_id) => {
  return axiosPrivate.post("getAudio", { prospecto_id })
    .then(res => res.data.data);
};

const getEvidenciaBonoDescuento = (bono_descuento_id) => {
  return axiosPrivate.post("getEvidenciaBonoDescuento", { bono_descuento_id })
    .then(res => res.data.data);
};

const getFicha = (usuario_id) => {
  return axiosPrivate.post("getFicha", { usuario_id })
    .then(res => res.data.data);
};

const getContrato = (usuario_id) => {
  return axiosPrivate.post("getContrato", { usuario_id })
    .then(res => res.data.data);
};

const getDni = (usuario_id) => {
  return axiosPrivate.post("getDni", { usuario_id })
    .then(res => res.data.data);
};

const getReciboLuzAgua = (usuario_id) => {
  return axiosPrivate.post("getReciboLuzAgua", { usuario_id })
    .then(res => res.data.data);
};

const getCertijoven = (usuario_id) => {
  return axiosPrivate.post("getCertijoven", { usuario_id })
    .then(res => res.data.data);
};

const guardarImagenInventario = (archivo_inventario, origen_id, usuario_id) => {
  const formData = new FormData();
  formData.append("archivo_inventario", archivo_inventario);
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);

  return axiosPrivate.post("guardarImagenInventario", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getImagenInventario = (origen_id) => {
  return axiosPrivate.post("getImagenInventario", { origen_id })
    .then(res => res.data.data);
};

const guardarFacturaInventario = (archivo_factura, origen_id, usuario_id) => {
  const formData = new FormData();
  formData.append("archivo_factura", archivo_factura);
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);

  return axiosPrivate.post("guardarFacturaInventario", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getFacturaInventario = (origen_id) => {
  return axiosPrivate.post("getFacturaInventario", { origen_id })
    .then(res => res.data.data);
};

const guardarReciboPorHonorarios = (archivo_recibo_honorarios, origen_id, usuario_id, periodo_fecha) => {
  const formData = new FormData();
  formData.append("archivo_recibo_honorarios", archivo_recibo_honorarios);
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);
  formData.append("periodo_fecha", periodo_fecha);

  return axiosPrivate.post("guardarReciboPorHonorarios", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getReciboPorHonorarios = (origen_id, periodo_fecha) => {
  return axiosPrivate.post("getReciboPorHonorarios", { origen_id, periodo_fecha })
    .then(res => res.data.data);
};


const guardarDocumentoPoi = (documento_poi, origen_id, usuario_id) => {
  const formData = new FormData();
  formData.append("documento_poi", documento_poi);
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);

  return axiosPrivate.post("guardarDocumentoPoi", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getFirmaDigitalConvenio = (origen_id) => {
  return axiosPrivate.post("getFirmaDigitalConvenio", { origen_id })
    .then(res => res.data.data);
};

const guardarFirmaDigitalConvenio = (archivo_firma_digital, origen_id, usuario_id) => {
  const formData = new FormData();
  formData.append("archivo_firma_digital", archivo_firma_digital);
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);

  return axiosPrivate.post("guardarFirmaDigitalConvenio", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getDocumentoPoi = (origen_id) => {
  return axiosPrivate.post("getDocumentoPoi", { origen_id })
    .then(res => res.data.data);
};

const guardarDocumentoServicioSistemas = (documento_servicio_sistemas, origen_id, usuario_id) => {
  const formData = new FormData();
  formData.append("documento_servicio_sistemas", documento_servicio_sistemas);
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);

  return axiosPrivate.post("guardarDocumentoServicioSistemas", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getDocumentoServicioSistemas = (origen_id) => {
  return axiosPrivate.post("getDocumentoServicioSistemas", { origen_id })
    .then(res => res.data.data);
};

const guardarImagenGantt = (origen_id, usuario_id, imagen_gantt) => {
  const formData = new FormData();
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);
  formData.append("imagen_gantt", imagen_gantt);
  return axiosPrivate.post("guardarImagenGantt", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getImagenesGantt = (origen_id) => {
  return axiosPrivate.post("getImagenesGantt", { origen_id })
    .then(res => res.data.data);
};

const eliminarImagenGantt = (archivo_id) => {
  return axiosPrivate.post("eliminarImagenGantt", { archivo_id })
    .then(res => res.data);
};

const guardarImagenInduccion = (imagen_induccion, origen_id, usuario_id) => {
  const formData = new FormData();
  formData.append("imagen_induccion", imagen_induccion);
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);
  return axiosPrivate.post("archivos/induccion/guardar", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getImagenesInduccion = () => {
  return axiosPrivate.post("archivos/induccion/listar")
    .then(res => res.data);
};

const eliminarImagenInduccion = (archivo_id) => {
  return axiosPrivate.post("archivos/induccion/eliminar", { archivo_id })
    .then(res => res.data);
};

const actualizarOrdenInduccion = (ordenes) => {
  return axiosPrivate.post("archivos/induccion/actualizar-orden", { ordenes })
    .then(res => res.data);
};

const guardarBoletaPago = (archivo_boleta, usuario_id, periodo_fecha, registrado_por) => {
  const formData = new FormData();
  formData.append("archivo_boleta", archivo_boleta);
  formData.append("usuario_id", usuario_id);
  formData.append("periodo_fecha", periodo_fecha);
  formData.append("registrado_por", registrado_por);

  return axiosPrivate.post("guardarBoletaPago", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getBoletaPago = (usuario_id, periodo_fecha) => {
  return axiosPrivate.post("getBoletaPago", { usuario_id, periodo_fecha })
    .then(res => res.data.data);
};

const getBoletasPagoPeriodo = (periodo_fecha) => {
  return axiosPrivate.post("getBoletasPagoPeriodo", { periodo_fecha })
    .then(res => res.data.data);
};

const guardarComprobantePago = (archivo_comprobante, usuario_id, periodo_fecha, registrado_por) => {
  const formData = new FormData();
  formData.append("archivo_comprobante", archivo_comprobante);
  formData.append("usuario_id", usuario_id);
  formData.append("periodo_fecha", periodo_fecha);
  formData.append("registrado_por", registrado_por);

  return axiosPrivate.post("guardarComprobantePago", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getComprobantePago = (usuario_id, periodo_fecha) => {
  return axiosPrivate.post("getComprobantePago", { usuario_id, periodo_fecha })
    .then(res => res.data.data);
};

const getComprobantesPagoPeriodo = (periodo_fecha) => {
  return axiosPrivate.post("getComprobantesPagoPeriodo", { periodo_fecha })
    .then(res => res.data.data);
};

const guardarDocumentoMemorandum = (documento_memorandum, origen_id, usuario_id) => {
  const formData = new FormData();
  formData.append("documento_memorandum", documento_memorandum);
  formData.append("origen_id", origen_id);
  formData.append("usuario_id", usuario_id);

  return axiosPrivate.post("guardarDocumentoMemorandum", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const getDocumentoMemorandum = (origen_id) => {
  return axiosPrivate.post("getDocumentoMemorandum", { origen_id })
    .then(res => res.data.data);
};

export default {
  guardarExpedientillo,
  getExpedientillo,
  guardarAudio,
  getAudio,
  getEvidenciaBonoDescuento,
  getFicha,
  getContrato,
  getDni,
  getReciboLuzAgua,
  getCertijoven,
  guardarImagenInventario,
  getImagenInventario,
  guardarFacturaInventario,
  getFacturaInventario,
  guardarReciboPorHonorarios,
  getReciboPorHonorarios,
  guardarDocumentoPoi,
  getDocumentoPoi,
  guardarFirmaDigitalConvenio,
  getFirmaDigitalConvenio,
  guardarDocumentoServicioSistemas,
  getDocumentoServicioSistemas,
  guardarImagenGantt,
  getImagenesGantt,
  eliminarImagenGantt,
  guardarImagenInduccion,
  getImagenesInduccion,
  eliminarImagenInduccion,
  actualizarOrdenInduccion,
  guardarBoletaPago,
  getBoletaPago,
  getBoletasPagoPeriodo,
  guardarComprobantePago,
  getComprobantePago,
  getComprobantesPagoPeriodo,
  guardarDocumentoMemorandum,
  getDocumentoMemorandum
};